import Icon from '../components/Icon.vue'

Icon.register({"bell-slash":{"width":576,"height":512,"paths":[{"d":"M78.1 366.1C48 396.2 69.3 448 112 448H224C224 483.3 252.7 512 288 512 323.3 512 352 483.3 352 448H384.7L127.8 221.4C125.7 318.5 99.4 344.8 78.1 366.1zM264 448C264 461.2 274.8 472 288 472A8-8 0 0 0 288 488C265.9 488 248 470.1 248 448H264zM569.9 491.7L559.1 503.8C550.2 513.8 534.8 514.8 524.7 506L8.3 54.4C-1.8 45.6-2.8 30.3 6.1 20.3L16.9 8.2C25.8-1.8 41.2-2.8 51.3 6L165.1 105.6C189.1 76.8 223.1 56.6 261.7 50.2A31.9-31.9 0 0 0 256 32C256 14.3 270.3 0 288 0S320 14.3 320 32C320 38.8 317.9 45 314.3 50.2 390.2 62.7 448 128.6 448 208 448 316.1 475.6 343.8 497.9 366.1 510 378.2 513.8 393.8 511.2 408.2L567.7 457.6C577.8 466.4 578.8 481.7 569.9 491.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bell-slash.js
// module id = GPK8
// module chunks = 0